import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../../user/selectors'
import { getPcrIdSelector } from '../../../../home/selectors'
import { PcrDocsService } from '../../../../../services/pcrDocs.service'
import { IPcr } from '../../../../pcr/store/pcr.types'
import { getPediatricTraumaScoreSelector } from '../selectors'
import { IPediatricTraumaScoreState } from '../store/pediatricTraumaScore.types'
import { PediatricTraumaScoreConstants } from '../store/pediatricTraumaScore.constants'
import { performWithMutexHOG } from '../../../../../services/mutexUtility.service'

export function* savePTS() {
  const ptsData: IPediatricTraumaScoreState = yield select(getPediatricTraumaScoreSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      prNabc: {
        ...pcrDoc.prNabc,
        ...ptsData,
      },
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`savePTS() error: ${e}`))
    }
  }
}

export function* savePTSSaga() {
  yield takeLatest([PediatricTraumaScoreConstants.SAVE_PTS_DATA], performWithMutexHOG, savePTS)
}
